var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000162314330280457366950000002490753123003357574_);}\n\t.st3{fill:url(#SVGID_00000070805316567773922620000014944124679770564496_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.8258,
    y1: 668.869,
    x2: 373.302,
    y2: 1160.2152,
    gradientTransform: "matrix(1 0 0 1 0 -454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DC1FFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.8,536.4c2.8-2.8,6.7-4.4,10.7-4.4h370.7c6.8,0,10.2,8.2,5.4,13l-73.2,73.2c-2.8,2.8-6.7,4.4-10.7,4.4H216 c-6.8,0-10.2-8.2-5.4-13L283.8,536.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058557702130713896390000005692128863906686883_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.6694,
    y1: 610.314,
    x2: 261.1457,
    y2: 1101.6603,
    gradientTransform: "matrix(1 0 0 1 0 -454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DC1FFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058557702130713896390000005692128863906686883_)"
    },
    d: "M283.8,263c2.9-2.8,6.8-4.4,10.7-4.4 h370.7c6.8,0,10.2,8.2,5.4,13l-73.2,73.2c-2.8,2.8-6.7,4.4-10.7,4.4H216c-6.8,0-10.2-8.2-5.4-13L283.8,263z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122701101162174283340000012530691725369655736_",
    gradientUnits: "userSpaceOnUse",
    x1: 573.3884,
    y1: 639.4039,
    x2: 316.8644,
    y2: 1130.7501,
    gradientTransform: "matrix(1 0 0 1 0 -454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DC1FFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122701101162174283340000012530691725369655736_)"
    },
    d: "M597.4,398.9c-2.8-2.8-6.7-4.4-10.7-4.4 H216c-6.8,0-10.2,8.2-5.4,13l73.2,73.2c2.8,2.8,6.7,4.4,10.7,4.4h370.7c6.8,0,10.2-8.2,5.4-13L597.4,398.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/solana_icon.84e029628bd0bddf81550c2874a92be1.svg";
export { ForwardRef as ReactComponent };